/* import __COLOCATED_TEMPLATE__ from './claim-modal.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import templateOnlyComponent from '@ember/component/template-only';

interface Args {
  badge: string;
  headline: string;
  body: string;
  claimCta: string;
  skipCta: string;
  onClaim: () => void;
  onSkip: () => void;
}

interface Signature {
  Args: Args;
}

const CompellingOfferClaimModal = templateOnlyComponent<Signature>();
export default CompellingOfferClaimModal;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'CompellingOffer::ClaimModal': typeof CompellingOfferClaimModal;
    'compelling-offer/claim-modal': typeof CompellingOfferClaimModal;
  }
}
